/* ----------------- React --------------- */
import { useState } from "react";

/* ----------------- Hooks --------------- */
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { formatDate, formatExamDate } from "@helpers/date";
import { isWeb } from "@helpers/platform";
import { getPurchasedProducts } from "@helpers/user";
import useExams from "@hooks/useExams";

export const useMoreSettings = () => {
	const {
		currentExamContext: { examIcon, examName, examDate },
	} = useExamContext();

	const [showExamsFilterDialog, setShowExamsFilterDialog] = useState(false);

	const toggleShowExamsFilterDialog = () => {
		setShowExamsFilterDialog((prev) => !prev);
	};

	const [showDatePicker, setShowDatePicker] = useState(false);

	const toggleShowDatePicker = () => {
		setShowDatePicker((prev) => !prev);
	};

	const { examsList } = useExams();

	const hasMoreThanOneExam = examsList.length > 1;

	const purchasedProducts = getPurchasedProducts(examsList);

	const moreSettingsSections = [
		{
			sectionTitle: "About You",
			data: [
				{
					icon: "account-outline" as const,
					title: "Profile",
					rightCta: "View",
					href: "/profile",
					type: "profile" as const,
				},
				// {
				// 	thumbnail: userIcon,
				// 	title: "Change avatar",
				// 	type: "change-avatar" as const,
				// 	rightIcon: "account-edit-outline" as const,
				// },
			],
		},
		{
			sectionTitle: "Account",
			data: [
				{
					icon: "cog-outline" as const,
					title: "Settings",
					rightCta: "View",
					href: "/account/settings",
					type: "account-settings" as const,
				},
			],
		},
		{
			sectionTitle: "Your Exam",
			data: [
				{
					thumbnail: examIcon,
					title: examName,
					rightCta: hasMoreThanOneExam ? "Switch" : undefined,
					type: "switch-exam" as const,
				},
				{
					icon: "calendar-outline" as const,
					type: "change-date" as const,
					title: examDate ? formatExamDate(examDate) : "Select date",
					rightCta: "Update",
				},
			],
		},
		...(purchasedProducts.length > 0
			? [
					{
						sectionTitle: "Your Subscriptions",
						data: [
							...(isWeb
								? [
										{
											icon: "gift-outline" as const,
											title: "Redeem Purchase",
											type: "redeem" as const,
											href: "/redeem?step=redeem",
										},
									]
								: []),
							...purchasedProducts.map(
								({
									bundle: {
										name,
										icon: { url },
										id,
									},
									metadata,
								}) => {
									const endDate = metadata.subscription?.endDate;
									return {
										title: name,
										subtitle: endDate
											? `Expires in ${formatDate(endDate)}`
											: "",
										rightCta: "Extend",
										type: "subscription" as const,
										thumbnail: url,
										id: id,
									};
								},
							),
						],
					},
				]
			: []),
	];

	return {
		moreSettingsSections,
		toggleShowDatePicker,
		showDatePicker,
		showExamsFilterDialog,
		toggleShowExamsFilterDialog,
		purchasedProducts,
		hasMoreThanOneExam,
	};
};
